import { render, staticRenderFns } from "./Viewbar.vue?vue&type=template&id=4618538d&scoped=true&"
import script from "./Viewbar.vue?vue&type=script&lang=ts&"
export * from "./Viewbar.vue?vue&type=script&lang=ts&"
import style0 from "./Viewbar.vue?vue&type=style&index=0&id=4618538d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4618538d",
  null
  
)

export default component.exports